// extracted by mini-css-extract-plugin
module.exports = {"averagePrice":"averagePrice-module__averagePrice--DPpDj","average":"averagePrice-module__average--A89sN"};